import Modal from 'react-modal';
import { useState } from 'react';
import { CloseButton, ShareButton } from './uw-online-shared/UwOnlineComponents.js'
import { GridRow } from './Grid'
import { SquareValue  } from "./Values";
import { convertSeconds } from './Time.ts'

export function HelpModal(props) {
    return (
        <Modal isOpen={props.isOpen}>
            <div className='how-to-page-wrapper'>
                <div className='how-to-page'>
                    
                    <div className='modal-controls'>
                        <CloseButton closer={props.closer} colourCode={props.colourCode}/>
                    </div>
                    <div className='how-to-page-toc'>
                        <div><a href="#howto">How to play</a></div>
                        <div><a href="#tips">Tips</a></div>
                        <div><a href="#privacy">Privacy Policy</a></div>
                        <div>&nbsp;</div>
                    </div>

                    <nav class="mobile-nav">
                        <span id="howto" className='modal-title-text'>How to play </span><GridRow size="40" row="0" letters={SquareValue.arrayFromLetters("GOGEN")}/>
                    </nav>
                    <p className="help-text">
                        The idea of Gogen is simple - although the puzzles themselves range from straightforwad to fiendish. 
                        Fill in the grid so that every word in the list can be spelled out by moving from letter to letter in any direction.
                    </p>
                    <p>e.g.: JIGSAW</p>
                    <img src="/img/docs/jigsaw-example.png"/>
                    <p>
                        One of the available squares on the grid will always be "selected" for typing into, it will appear in a lighter green, like this:
                    </p>
                    <img src="/img/docs/selected-grid.png"/>
                    <p>
                        You need to place every letter (except Z) exactly once. The letters in the dark green squares are fixed - the 
                        keyboard will change every game to show the 16 letters you can control. 
                        If you place a letter and change your mind, you can <img style={{height:"1.2em", marginBottom: "-0.3em"}} src="/img/docs/delete-narrow.png"/> it.
                    </p>
                    <p>
                        The game has a <img style={{height:"1.2em", marginBottom: "-0.3em"}} src="/img/docs/note-mode-narrow.png"/> so 
                        you can make notes of the possibile answers in each square. Notes will get tidied up automatically as you 
                        place letters in the grid. To remove a note from one square, select the square, make sure you are in 
                        Note Mode, and click the letter on the keyboard.
                    </p>
                    <p>
                        The puzzle is complete when all the letters are placed and all the words in the list can be found 
                        in your answer. Sometimes there might be more than one right answer because one or more pairs of 
                        letters can be flipped. As long as the words are all there, you've solved it.
                    </p>
                    <p>
                        <span id="tips" className='modal-title-text'>Tips for solving</span>
                    </p>
                    <p>
                        Diagonals are one of the keys to solving Gogen. Whether it's within the same word or from separate words,
                        if a letter is next to two others that are on a diagonal, then it MUST go between them. For example:
                        [same word image]
                        [different word image]

                        Compare that to being between two letters horizontally or vertically:
                        [hoz image]
                        [ver image]

                        Another tip if you can't see any next steps in the puzzle is to carefully fill out the notes 
                        of what can go where based on the letters you already know. If you see something like this:
                        [image of pair of note pairs plus pair+1]
                        then you actually know that C goes in the A+B+C square because A and B MUST go (one way or the other) 
                        in the squares that only have A and B as notes
                    </p>

                    <p>
                        <span id="howto" className='modal-title-text'>Privacy policy </span>
                    </p>
                    <p id="privacy">
                        The Privacy Policy for all UrbanWizardry.com websites and games can be found <a href="https://urbanwizardry.com/privacypolicy" target="_blank">🔗 Here</a>
                    </p>
                </div>
            </div>

        </Modal>
    )
}

export function StatsSettingsModal(props) {
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const todaysPuzzle = [];
    if (props.completeToday) {
        todaysPuzzle.push(
            <div style={{borderWidth: "thin", borderRadius: "10px", borderStyle: "solid", padding: "20px"}}>
                <p style={{fontWeight: "bold"}}>
                    You solved today's puzzle in:
                </p>
                <p style={{fontWeight: "bold"}}>
                    {convertSeconds(props.completedSeconds)}
                </p>
                <ShareButton onShare={props.onShare}/>
            </div>
        )
    }
    return (
        <Modal isOpen={props.isOpen}>
            <div className='modal-controls'>
                <CloseButton closer={props.closer} colourCode={props.colourCode}/>
            </div>
            <nav class="mobile-nav">
                <div style={{display: "flex", alignContent:"end"}}>
                        <span className="modal-title-text">Stats</span>
                </div>
            </nav>
            <div className='stats-table'>
                <div><span>Games played:</span><span>{props.stats.played}</span></div>
                <div><span>Current Streak:</span><span>{props.stats.streak}</span></div>
                <div><span>Average game time:</span><span>{convertSeconds(props.stats.averageSeconds)}</span></div>
            </div>
            {todaysPuzzle}


        </Modal>
    )
}

export function SolvedModal(props) {
    return (
    <Modal isOpen={props.isOpen}>
        <div className='modal-header'>
            <div className='modal-controls'>
                <CloseButton closer={props.closer} colourCode={props.colourCode}/>
            </div>
            <nav class="mobile-nav">
                <GridRow size="40" row="0" letters={SquareValue.arrayFromLetters("GREAT")}/>
                <GridRow size="40" row="1" letters={SquareValue.arrayFromLetters("STUFF")}/>
                <GridRow size="40" row="2" letters={SquareValue.arrayFromLetters("CHAMP")}/>
            </nav>
        </div>

        <p style={{textAlign: "center"}}>
            You solved the GOGEN in:
        </p>
        <p style={{textAlign: "center", fontWeight: "bold"}}>
            {convertSeconds(props.solvedTime)}
        </p>

        <ShareButton onShare={props.onShare} gameButtonClass="gogen-online-button"/>

        <ModalAd/>

    </Modal>
    )
}

export function RestartConfirmModal(props) {
    return (
        <Modal isOpen={props.isOpen}>
        <div className='modal-header'>
            <div className='modal-controls'>
                <CloseButton closer={props.closer} colourCode={props.colourCode}/>
            </div>
            <nav class="mobile-nav">
                <GridRow size="40" row="0" letters={SquareValue.arrayFromLetters("RESET")}/>
            </nav>
        </div>
        <p style={{textAlign: "center", fontWeight: "bold"}}>
            Are you sure you want to reset today's game and start again?
        </p>        

        <YesNoButtons onYes={props.onYes} onNo={props.onNo}/>

        </Modal>
    )
}

function YesNoButtons(props) {
    return (
        <div className='yes-no-button-wrapper'>
            <button type="button" className='online-game-button gogen-online-button' onClick={props.onYes}>Yes</button>
            <button type="button" className='online-game-button gogen-online-button-red' onClick={props.onNo}>No!</button>
            
        </div>
    )
}

function ModalAd(props) {
    return (
        <div className='banner-300x250' style={{width: "calc(100% + 40px)", marginLeft: "-20px", display: "flex", justifyContent: "center"}}>
            {/* <div style={{width: 300, height: 250, display:"flex", alignContent: "center", justifyContent: "center", backgroundColor: "gray"}}>
                This is an ad!
            </div> */}
        </div>
    )
}